
import { computed, defineComponent, ref } from "vue";
import Masthead from "@/components/custom/layout/Masthead.vue";
import { useQuery } from "@vue/apollo-composable";
import { soalanLazimPublicList } from "@/apollo/public/soalanLazim";

export default defineComponent({
  name: "help-page",
  components: {
    Masthead,
  },
  setup() {
    const headerConfig = ref([
      {
        name: "Bil.",
        key: "bil",
        sortable: true,
      },
      {
        name: "Manual Pengguna",
        key: "panduan",
        sortable: true,
      },
    ]);

    const headerConfig2 = ref([
      {
        name: "Bil.",
        key: "bil",
        sortable: true,
      },
      {
        name: "Video Manual Pengguna",
        key: "panduanvideo",
        sortable: true,
      },
    ]);

    const { result } = useQuery(soalanLazimPublicList, null, {
      fetchPolicy: "no-cache",
    });
    const filter = ref("");

    const soalanLazimList = computed(() => {
      const soalanLazim = result.value?.soalanLazimListPublic ?? [];
      let clone = JSON.parse(JSON.stringify(soalanLazim));
      if (filter.value)
        clone = clone.filter((soalan) => soalan.jenis == filter.value);
      return clone;
    });

    const strToBase64 = (payload) => {
      return btoa(unescape(encodeURIComponent(payload)));
    };

    const jenisLabel = (type) => {
      switch (type) {
        case "PP":
          return "PEPERIKSAAN";
        case "PK":
          return "PERKHIDMATAN";
        case "UM":
          return "UMUM";
        default:
          return "";
      }
    };

    const getUserManual = (fileName: string) => {
      const url = `/files/${fileName}.pdf`;
      window.open(url, "_blank");
    };

    const getVid = (name: string) => {
      const url = `videos/${name}.mp4`;
      window.open(url, "_blank");
    };

    return {
      soalanLazimList,
      strToBase64,
      jenisLabel,
      filter,
      headerConfig,
      headerConfig2,
      getUserManual,
      getVid,
    };
  },
});
